import { createAsyncThunk } from '@reduxjs/toolkit';
import apiInstance from '../../Apis/Axios';
import axios from "axios";
import {URL} from "../../Apis/Constants";
import { FILE_SERVICE} from '../EndPoints';

export const MarkFilesAsRead = createAsyncThunk('report/markFilesAsRead', async (body) => {
    const response = await apiInstance
        .post('report-service/v1/notifications/mark-as-read', body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const DownloadReportByName = createAsyncThunk(
    'report/downloadReportByName',
    async (params, { dispatch, getState }) => {
        const { name } = params;
        const result = await apiInstance
            .get(`${FILE_SERVICE.downloadReportByName}${name}`, { responseType: 'blob' })
            .then(function (response) {
                const currentdate = new Date();
                const datetime =
                    currentdate.getFullYear() +
                    '-' +
                    (currentdate.getMonth() + 1) +
                    '-' +
                    currentdate.getDate() +
                    '_' +
                    currentdate.getHours() +
                    '-' +
                    currentdate.getMinutes() +
                    '-' +
                    currentdate.getSeconds();

                const fileExtension = name.split('.').pop();

                const fileName = `${name}-${datetime}.${fileExtension}`;

                const url = window?.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;

                link.setAttribute('download', fileName);

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        return result;
    },
);

/**
 * Trigger WebSocket notification push for a user
 * This POST will ask the backend to send the latest reports to the WebSocket topic
 *
 * @param {void} - We don't send userId directly because the backend resolves it from TokenClaims
 */
export const TriggerNotificationsByUser = createAsyncThunk(
    'report/triggerNotificationsByUser',
    async ({ userId, token }, { rejectWithValue }) => {
        try {
            await axios.post(`${URL}websocket/notifications/?userId=${userId}`, null, {
                headers: { Authorization: `Bearer ${token}` },
            });
            return { success: true };
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);
